export default function Comparable() {}